import React from "react";
import { useMemoizedCallback } from "./useMemoizedCallback";

// inspired by https://github.com/streamich/react-use/blob/master/src/useClickAway.ts

export default function useClickAway({
  callback,
  ref,
  enable = true,
}: {
  callback: (event: Event) => void;
  ref: React.RefObject<HTMLElement | null>;
  enable: boolean;
}) {
  const savedCallback = useMemoizedCallback(callback);

  React.useEffect(() => {
    function handler(ev: Event) {
      if (!ref || !ref.current || ref.current.contains(ev.target as Node)) {
        return;
      }

      savedCallback(ev);
    }

    if (!enable) {
      return;
    }

    document.addEventListener("mousedown", handler, false);
    return () => document.removeEventListener("mousedown", handler, false);
  }, [savedCallback, ref, enable]);
}
